import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  createTerminalUpdate,
  deleteTerminalUpdate,
  fetchTerminalUpdates,
  updateTerminalUpdate,
} from "../../apis/terminalUpdates";

import type { TerminalUpdate } from "../../utils/types/terminalUpdates";

const getTerminalUpdateErrorMessage = (error: any, fallback: string) =>
  error?.response?.data?.message || error?.message || fallback;

interface EditTerminalUpdateArgs {
  id: string;
  data: Partial<TerminalUpdate>;
}

interface EditTerminalUpdateResult {
  oldId: string;
  newRecord: TerminalUpdate;
}

export const fetchTerminalUpdatesList = createAsyncThunk(
  "terminalUpdates/fetchList",
  async (portCallingsId: string | undefined, { rejectWithValue }) => {
    try {
      return await fetchTerminalUpdates(portCallingsId);
    } catch (error: any) {
      return rejectWithValue(
        getTerminalUpdateErrorMessage(error, "Failed to fetch terminal updates")
      );
    }
  }
);

export const addTerminalUpdate = createAsyncThunk(
  "terminalUpdates/add",
  async (
    { data }: { data: Partial<TerminalUpdate> },
    { rejectWithValue }
  ) => {
    try {
      return await createTerminalUpdate(data);
    } catch (error: any) {
      return rejectWithValue(
        getTerminalUpdateErrorMessage(error, "Failed to create terminal update")
      );
    }
  }
);

export const editTerminalUpdate = createAsyncThunk(
  "terminalUpdates/edit",
  async (
    { id, data }: EditTerminalUpdateArgs,
    { rejectWithValue }
  ) => {
    try {
      const newRecord = await updateTerminalUpdate(id, data);
      return { oldId: id, newRecord } satisfies EditTerminalUpdateResult;
    } catch (error: any) {
      return rejectWithValue(
        getTerminalUpdateErrorMessage(error, "Failed to update terminal update")
      );
    }
  }
);

export const removeTerminalUpdate = createAsyncThunk(
  "terminalUpdates/remove",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      return await deleteTerminalUpdate(id);
    } catch (error: any) {
      return rejectWithValue(
        getTerminalUpdateErrorMessage(error, "Failed to delete terminal update")
      );
    }
  }
);
